import { ReactElement, ReactNode } from 'react'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import Button from 'Root/App/Button'
import Title from 'Root/App/Title'

library.add(faClose)

interface Props {
  children: ReactNode
  title: string | ReactElement
  cta?: ReactNode
  onClose: () => void
}

const PanelLayout: React.FC<Props> = ({ children, title, cta, onClose }) => {
  return (
    <span className="flex flex-col gap-4 overflow-auto sm:gap-6">
      <Dialog.Title className="flex items-center justify-between">
        <Title>{title}</Title>
        <Button className="p-0 w-5 h-5 bg-white outline-none" onClick={onClose}>
          <FontAwesomeIcon
            className="text-gray-500 text-sm"
            icon={['fas', 'close']}
          />
        </Button>
      </Dialog.Title>

      {children}

      {cta && (
        <span className="flex gap-6 justify-end mt-2 w-full sm:mt-3">
          {cta}
        </span>
      )}
    </span>
  )
}

export default PanelLayout
